<template>
    <v-container fluid grid-list-xl>
        <v-toolbar  color="#FAFAFA" flat>
            <v-btn icon outline color="primary"  to="/distribuir">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title >Pacote</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn color="yellow">salvar rascunho</v-btn>
            <v-btn color="green" dark @click="salvar" :disabled="publishButtonDisabled">Continuar</v-btn>
        </v-toolbar>
<v-divider></v-divider>

        <v-layout wrap white>
            <v-flex xs12 md4>
                <v-text-field
                    class="purple-input"
                    label="Pacote"
                    messages="Esse valor é automático e nos ajuda a monitorar o pacote durante o processamento interno e nos parceiros."
                    disabled
                    v-model="pack.package_name"
                />
            </v-flex>

            <v-flex xs12 md8>
                <v-text-field
                    class="purple-input"
                    label="Descrição"
                    messages="Use esse espaço para te ajudar no futuro a identificar a criação desse pacote."
                    v-model="pack.description"
                />
            </v-flex>

            <v-expansion-panel v-model="panel" expand inset>
                <v-expansion-panel-content :value="true">
                    <template v-slot:header>
                        <div class="font-weight-small title">Ação</div>
                        <v-spacer></v-spacer>Passo 1 de 3
                    </template>
                    <v-card>
                        <v-layout px-3 wrap>
                            <v-flex xs12 md9>
                                <v-radio-group v-model="pack.action" row>
                                    <v-radio label="ENVIAR" value="insert"></v-radio>
                                    <v-radio label="ATUALIZAR" value="update"></v-radio>
                                    <v-radio label="REMOVER" value="takedown"></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs12 md3>
                                Escolha uma das ações disponíveis para esse pacote.
                                <br />
                                <br />A ação é por pacote e será aplicada a todas plataformas e produtos selecionados.
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                    </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content
                    :disabled="disabledPanel(2)"
                    :value="disabledPanelExpanded(2)"
                >
                    <template v-slot:header>
                        <div class="font-weight-small title">Plataformas</div>
                        <v-spacer></v-spacer>Passo 2 de 3
                    </template>
                    <v-card>
                        <v-layout px-3 wrap>
                            <v-flex xs12 md9>
                                <v-layout row wrap>
                                    <v-flex
                                        xs6
                                        md4
                                        v-for="platform in $store.getters.platforms_streamings"
                                        :key="platform.id"
                                    >
                                        <v-checkbox
                                            row
                                            v-model="platforms"
                                            :label="platform.name"
                                            :value="platform.id"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-flex xs12 md3>
                                Escolha ao menos uma plataforma para a ação selecionada.
                                <br />
                                <br />Em seguida faremos o processamento de cada plataforma individualmente e manteremos um status para que você consiga acompanhar.
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                    </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content
                    :disabled="disabledPanel(3)"
                    :value="disabledPanelExpanded(3)"
                >
                    <template v-slot:header class="background-color:green">
                        <div class="font-weight-small title">Produtos</div>
                        <v-spacer></v-spacer>Passo 3 de 3
                    </template>
                    <v-card>
                        <v-layout px-3 wrap>
                            <v-flex xs12 md9>
                                <v-layout row wrap>
                                    <v-flex xs12 md12>
                                        <v-autocomplete
                                            v-model="albums"
                                            :items="items"
                                            :loading="isLoading"
                                            :search-input.sync="search"
                                            color="white"
                                            hide-selected
                                            item-text="resumo"
                                            item-value="id"
                                            no-data-text="Nenhum produto encontrado"
                                            placeholder="Busque e selecione os produtos para esse pacote"
                                            return-object
                                            multiple
                                            chips
                                            deletable-chips
                                            item-avatar
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-data-table
                                            v-if="albums.length"
                                            :items="albums"
                                            class="elevation-1"
                                            hide-actions
                                            hide-headers
                                            no-data-text="Adicione um ou mais produtos"
                                        >
                                            <template v-slot:items="props">
                                                <td>{{ props.item.name }}</td>
                                                <td
                                                    class="text-xs-right"
                                                >{{ props.item.artist_name }}</td>
                                                <td class="text-xs-right">{{ props.item.upc }}</td>
                                                <td
                                                    class="text-xs-right"
                                                >{{ props.item.release_date }}</td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 md3>
                                Adicione os produtos a esse pacote buscando-o pelo código de barras, nome do produto ou nome do artista.
                                <br />
                                <br />É necessário ao menos um produto para que seja possível processar e publicar esse produto.
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-layout>
<!-- NAVIGATION -->
        <v-navigation-drawer
            v-model="dialog"
            :mini-variant="mini"
            absolute      
            temporary
            right
            clipped
            floating
            app
        >
      <v-card>
            <v-card-title class="title">Confirmação</v-card-title>
            <v-card-text>
                Ao continuar um pacote será criado e entrará na fila de processamento. O processamento dessa pacote pode
                interrompido enquanto o status estiver "<u>aguardando</u>". Após a alteração do status
                pelo sistema de processamento ele não pode ser mais parado.
            </v-card-text>
      </v-card>
      <v-card flat>  
                    <v-card-title class="title">Resumo da operação</v-card-title>
                    <v-card-text>
                        <p><b>Ação:</b> {{pack.action}}</p>
                        <p><b>Plataformas:</b> 
                            <ul v-if="platforms.length>0" class="px-4">
                                <li v-for="plat in getSelectedPlatforms()" :key="plat.id">{{ plat.name }} </li>
                            </ul>
                        </p>
                        <p><b>Produtos:</b> {{ albums.map(function(e){ return e.resumo;}).join(", ") }}</p>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                         <v-spacer></v-spacer>
                        <v-btn dark color="red" @click="salvarPacote">PUBLICAR</v-btn>
                    </v-card-actions>
                </v-card>
        </v-navigation-drawer>

        <!-- Dialog -->
    <v-dialog v-model="dialog_finished" persistent max-width="400px">
      <v-card>
        <v-card-title class="headline">Pacote finalizado</v-card-title>

        <v-card-text>Esse pacote foi enviado para processamento confira o histórico para acompanhar as etapas.</v-card-text>

        <v-card-actions>
          <v-btn color="green darken-1" flat="flat" @click="dialog_close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
</template>

<script>
import ProductService from "../../app/Rest/product";
import PackageService from "../../app/Rest/package";

const productService = ProductService.build();
const packageService = PackageService.build();

export default {
    data() {
        return {
            albums: [],
            platforms:[],
            items: [],
            mini:false,
            dialog_finished: false,
            panel: [true, false, false],
            search: null,
            dialog: false,
            isLoading: false,
            pack: { platforms: [], albums: [], action: null }
        };
    },    
    created: function() {
        if (!this.pack.package_name) {
            this.pack.package_name = this.generatePackageName();                        
        }
    },
    computed: {
        publishButtonDisabled: function() {
            return !(
                this.pack.action != null && //se uma acao foi selecionada
                this.platforms.length > 0 && //se ao menos uma plataforma foi selecionada
                this.albums.length > 0
            ); //se ao menos um album foi selecionado
        }
    },
    methods: {
        dialog_close:function(e){
            console.log(e);
            this.dialog_finished = false;
            this.$router.push('/distribuir');            
        },
        disabledPanel: function(val) {
            switch (val) {
                case 2:                    
                    return this.pack.action == null;
                    break;
                case 3:                    
                    return !(this.platforms.length > 0);
                    break;
            }
        },
        disabledPanelExpanded: function(val) {
            return !this.disabledPanel(val);
        },
        generatePackageName: function() {
            let curdate = new Date();
            let month = this.appendLeadingZeroes(curdate.getMonth() + 1);
            let day = this.appendLeadingZeroes(curdate.getDate());
            let year = curdate.getFullYear();
            let hour = this.appendLeadingZeroes(curdate.getHours());
            let minutes = this.appendLeadingZeroes(curdate.getMinutes());
            let seconds = this.appendLeadingZeroes(curdate.getSeconds());

            return [year, month, day, hour, minutes, seconds].join("");
        },
        //https://codehandbook.org/javascript-date-format/
        appendLeadingZeroes: function(n) {
            if (n <= 9) {
                return "0" + n;
            }
            return n;
        },
        salvarRascunho: function() {
            this.salvarPacote("draft");
        },
        salvar: function(status = null) {
            if (status == null) {
                status = "waiting";
            }
            this.dialog = true;
        },
        salvarPacote: function(status){
            if (status == null) {
                status = "waiting";
            }

            this.$store.dispatch("loading_full");
            this.pack.albums = this.albums;
            this.pack.platforms = this.getSelectedPlatforms();
            packageService.salvar(this.pack).then( e=>{
                this.pack = e.items.package;                
                this.albums = e.items.products;
                this.platforms = e.items.platforms.map( (e)=>{
                    return e.id;
                });
                this.dialog_finished = true;
                                
            }).finally( ()=>{
                this.$store.dispatch("loading_full");
            });

        },
        getSelectedPlatforms: function(){
            let plats = this.$store.getters.platforms_streamings;

            return this.platforms.map((plat_id)=>{
                return plats.filter( (plat_obj)=>{
                    return (plat_obj.id == plat_id);
                })[0]
            })
            
        }
    },
    watch: {
        search(val) {
            // Items have already been loaded
            //if (this.items.length > 0) return;
            if (val == "") return;
            if (val.length < 3) return;

            // Items have already been requested
            if (this.isLoading) return;

            this.isLoading = true;

            productService
                .searchProducts(val)
                .then(e => {
                    this.items = e.items.products;
                    this.isLoading = false;
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => (this.isLoading = false));
        }
    }
};
</script>